import React from 'react';
import { Link } from 'react-router-dom';
import { FaFacebook } from "react-icons/fa";
import { FaLinkedin } from "react-icons/fa";
import { FiInstagram } from "react-icons/fi";
import { FaYoutube } from "react-icons/fa";


const Footer = () => {
  return (
    <footer className="bg-gray-950 text-gray-400 py-12 px-4 md:px-8 lg:px-16 mt-auto">
      <div className="container mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Logo, Description, and Contact Section */}
          <div className="space-y-6">
            <div className="flex items-center space-x-2">
              <span className="text-xl font-bold text-white tracking-widest uppercase">SRK Softwares</span>
            </div>
            <p className="text-sm leading-relaxed">
              SRK Softwares is a leading IT solutions company specializing in custom software development,
              web design, and digital marketing. We are committed to delivering high-quality, innovative solutions
              that drive business growth and success for our clients.
            </p>
            <div className="flex flex-col space-y-4">
              <Link to="/contact" className="bg-orange-500 text-white font-semibold py-3 px-6 rounded-full shadow-lg hover:bg-orange-600 transition-colors duration-200 text-center">
                Book FREE Consultation
              </Link>
              <div className="flex items-center space-x-4">
                {/* Social Media Links - using SVG icons */}
                <a href="https://www.facebook.com/erajaythakur007" className="bg-gray-800 p-2 rounded-full hover:bg-white hover:text-gray-900 transition-colors duration-200" target='_blank'>
                  <FaFacebook/>
                </a>
                <a href="https://www.instagram.com/srksoftwares/" className="bg-gray-800 p-2 rounded-full hover:bg-white hover:text-gray-900 transition-colors duration-200" target='_blank'>
                  <FiInstagram/>
                </a>
                <a href="https://www.linkedin.com/in/meetajaythakur007/" className="bg-gray-800 p-2 rounded-full hover:bg-white hover:text-gray-900 transition-colors duration-200" target='_blank'>
                 <FaLinkedin/>
                </a>
                <a href="https://www.youtube.com/@srksoftwares" className="bg-gray-800 p-2 rounded-full hover:bg-white hover:text-gray-900 transition-colors duration-200" target='_blank'>
                 <FaYoutube/>
                </a>
              </div>
            </div>
          </div>

          {/* Our Specialization Section */}
          <div className="space-y-4">
            <h3 className="bg-gray-800 text-white font-semibold py-2 px-4 rounded-lg inline-block">Our Specialization</h3>
            <ul className="space-y-2 text-left">
              <li><Link to="/social-media-reputation-management" className="hover:text-white transition-colors duration-200">Full Digital Appearance Setup</Link></li>
              <li><Link to="/local-seo-gmb" className="hover:text-white transition-colors duration-200">Local SEO Services</Link></li>
              <li><Link to="/custom-seo-solution" className="hover:text-white transition-colors duration-200">Custom Design</Link></li>
              <li><Link to="/wordpress-design" className="hover:text-white transition-colors duration-200">Wordpress Design</Link></li>
              <li><Link to="/web-development" className="hover:text-white transition-colors duration-200">Web App Development</Link></li>
              <li><Link to="/mobile-app-development" className="hover:text-white transition-colors duration-200">Mobile App Development</Link></li>
              <li><Link to="/social-media-marketing" className="hover:text-white transition-colors duration-200">Social Media Marketing</Link></li>
              <li><Link to="/ppc" className="hover:text-white transition-colors duration-200">Paid Marketing</Link></li>
            </ul>
          </div>

          {/* We Serve Section */}
          <div className="space-y-4">
            <h3 className="bg-gray-800 text-white font-semibold py-2 px-4 rounded-lg inline-block">We Serve</h3>
            <ul className="space-y-2 text-left">
              <li><Link to="/online-appointment-system" className="hover:text-white transition-colors duration-200">Hospital and Doctors</Link></li>
              <li><Link to="/" className="hover:text-white transition-colors duration-200">Event Planner</Link></li>
              <li><Link to="/" className="hover:text-white transition-colors duration-200">Restaurants</Link></li>
              <li><Link to="/" className="hover:text-white transition-colors duration-200">Finance</Link></li>
              <li><Link to="/" className="hover:text-white transition-colors duration-200">Education</Link></li>
              <li><Link to="/" className="hover:text-white transition-colors duration-200">E-commerce</Link></li>
              <li><Link to="/" className="hover:text-white transition-colors duration-200">Small Business</Link></li>
              <li><Link to="/" className="hover:text-white transition-colors duration-200">Real Estate</Link></li>
              <li><Link to="/" className="hover:text-white transition-colors duration-200">Rehab Center</Link></li>
            </ul>
          </div>

          {/* Our Company Section */}
          <div className="space-y-4">
            <h3 className="bg-gray-800 text-white font-semibold py-2 px-4 rounded-lg inline-block">Our Company</h3>
            <ul className="space-y-2 text-left">
              <li><Link to="/about-srk" className="hover:text-white transition-colors duration-200">About Us</Link></li>
              <li><Link to="/contact" className="hover:text-white transition-colors duration-200">Contact Us</Link></li>
              <li><Link to="/contact" className="hover:text-white transition-colors duration-200">Appointment</Link></li>
             {/*  <li><Link to="#" className="hover:text-white transition-colors duration-200">Latest Blogs</Link></li> */}
              <li><Link to="/contact" className="hover:text-white transition-colors duration-200">Internship</Link></li>
              <li><Link to="/terms-and-conditions" className="hover:text-white transition-colors duration-200">T&C</Link></li>
              <li><Link to="/privacy-policy" className="hover:text-white transition-colors duration-200">Privacy Policy</Link></li>
              <li><Link to="/refund-policy" className="hover:text-white transition-colors duration-200">Return Policy</Link></li>
            </ul>
           <div className="mt-6 space-y-3">
              <a
                href="mailto:hr@srksoftwares.com"
                className="flex items-center space-x-2 border border-yellow-500 rounded-lg py-2 px-4 transition-colors duration-200 hover:bg-yellow-500 hover:text-black" target='_blank'
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                  <polyline points="22,6 12,13 2,6" />
                </svg>
                <span>hr@srksoftwares.com</span>
              </a>

              <a
                href="mailto:contact@srksoftwares.com"
                className="flex items-center space-x-2 border border-blue-500 rounded-lg py-2 px-4 transition-colors duration-200 hover:bg-blue-500 hover:text-black" target='_blank'
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                  <polyline points="22,6 12,13 2,6" />
                </svg>
                <span>contact@srksoftwares.com</span>
              </a>
            </div>

          </div>
        </div>
      </div>
    </footer>
  );
};


export default Footer;